/**
 * Module dependencies.
 */

import { Alert, AlertDescription, AlertTitle } from 'app/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { requiredRule } from 'app/core/utils/field-rules';
import { useBankAccounts } from 'app/hooks/requests/bank-accounts/use-bank-accounts';
import { BankAccount } from 'app/types/bank-account';
import { useCheckAccount } from '../hooks/use-check-account';
import { FormList } from 'app/components/organisms/crud/form-types';
import React from 'react';
import { TFunction } from 'react-i18next';
import { formFieldsAccountSelected } from './form-fields-account-selected';

/**
 * Form list.
 */

export const formFields = (translate: TFunction, data: any): FormList => [
  {
    type: 'selectField',
    name: 'accountId',
    label: translate('common.labels.account'),
    rules: requiredRule(translate),
    options: {
      hook: useBankAccounts,
      hookProps: () => [{ append: 'transactions' }],
      normalize: (items: BankAccount[]) =>
        items?.map(item => ({
          value: item.id,
          label: item.name
        }))
    }
  },
  {
    type: 'if',
    name: 'need_account_id',
    condition: {
      hook: useCheckAccount
    },
    elseIf: [
      {
        type: 'render',
        name: 'invalid_bank_account',
        render: (
          <Alert className={'mb-4 max-w-[500px]'} variant={'destructive'}>
            <AlertCircle className={'h-4 w-4'} />

            <AlertTitle>{translate('bankAccounts.add.invalidAccount.title')}</AlertTitle>

            <AlertDescription>{translate('bankAccounts.add.invalidAccount.description')}</AlertDescription>
          </Alert>
        )
      }
    ],
    thenIf: formFieldsAccountSelected(translate, data)
  }
];
